import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

export const useRequestSetHideUninstalledFromDecks = () => {
	const queryClient = useQueryClient();
	const { isPending, mutateAsync, error } = useMutation({
		mutationFn: (hide: boolean) =>
			apiClient
				.put(routes.api.pushUninstalls.hideFromDecks, { hide })
				.then(handleApiResponse),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [routes.api.pushUninstalls.base] });
		},
	});

	return {
		isLoading: isPending,
		setHideFromDecks: mutateAsync,
		error,
	};
};
